import DatamodelPage from "@/platform/components/datamodel/datamodel-page";


const EntityDetails = () => {
    return (
    <div className="entity-details-page">
      <DatamodelPage datamodelType="entity" />  
    </div>
  );
};

export default EntityDetails;